import React from "react";

function ViewCategory({ data }) {
  return (
     <>
        <div className="row mb-2">
          <div className="col-4 fw-bold">Name</div>
          <div className="col-8">{data?.name || "-"}</div>
        </div>
        <div className="row">
          <div className="col-4 fw-bold">Status</div>
          <div className="col-8">
            {data?.status === 1 ? (
              <span className="badge bg-success">Active</span>
            ) : (
              <span className="badge bg-danger">Inactive</span>
            )}
          </div>
    
      
    </div>
    </>
  );
}

export default ViewCategory;